var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('button',{on:{"click":_vm.addUnit}},[_vm._v("Add unit")])]),_vm._v(" "),_vm._l((_vm.hist_units),function(unit){return _c('HistUnitsBaseComp',_vm._b({key:unit.id,on:{"deleteUnit":_vm.onDeleteUnit}},'HistUnitsBaseComp',unit,false))})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07866e79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/HistUnits.vue
// module id = null
// module chunks = 